module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 53
// module chunks = 20 21